import { useEffect, useMemo, useState } from 'react';

import { TaskApi } from '../../../../../../api';

export default function useTaskTopics() {
  const [allTopics, setAllTopics] = useState([]);

  useEffect(function() {
    TaskApi.getTaskTopics().then(({ data: topics }) => {
      setAllTopics(topics);
    });
  }, []);

  const topicsMap = useMemo(
    function() {
      return allTopics?.reduce(function(accumulator, value) {
        return { ...accumulator, [value.id]: value };
      }, {});
    },
    [allTopics]
  );

  return useMemo(() => {
    return { allTopics, topicsMap };
  }, [allTopics, topicsMap]);
}
